import Shared from "emun.cart/cart.controller";
import retailerConfig from "emun.retailer/retailer.config";
import formioController from "webforms/formio/formio.controller";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import requestPrompt from "emun.retailer/retailer-forms-prompt";
import formSubmissionPrompt from "emun.retailer/retailer-form-submission-prompt";

export default class CartFormsController extends Shared {
  constructor($cart, $scope) {
    super($cart);
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.$cart = $cart;
    $ctrl.retailerId = $cart.retailerId;
    $ctrl.bus = new ServiceBus();
    $ctrl.retailerConfig = retailerConfig;
    $ctrl.formSubmitted = false;
    $ctrl.query = new AutoQuery({
      url: `QueryFormConfigs.json`,
      criteria: {
        FormType: "Customer",
        VendorId: $cart.vendorId,
      },
      onLoaded: function (configs) {
        if ($ctrl.formId) {
          configs.results.forEach((config) => {
            if ($ctrl.formId === config.id) $ctrl.selectForm(config);
          });
        }
        $ctrl.bus
          .send(`QueryFormSubmissions.json?RefId=${$cart.retailerId}`)
          .then((res) => {
            res.data.results.forEach((submission) => {
              configs.results.forEach((config) => {
                if (submission.label === config.id) config.submitted = true;
              });
            });
          });
      },
      orderBy: "Label",
      append: false,
      autoLoad: true,
      pageSize: 24,
      disableQueryString: !!$ctrl.disableQueryString,
      hideLeftNav: true,
    });
    if ($ctrl.retailerId && !$ctrl.retailer) {
      $ctrl.bus
        .send(`QueryRetailers.json?Id=${$ctrl.retailerId}`)
        .then(function (res) {
          if (res.data.results) {
            $ctrl.retailer = res.data;
          }
        });
    }
    $ctrl.bus
      .send(
        `QueryRetailerShippingLocations.json?RetailerId=${$ctrl.retailerId}`
      )
      .then(function (res) {
        if (res.data.results) {
          $ctrl.shippingLocation = res.data.results[0];
        }
      });
    $ctrl.bus
      .send(
        `QueryRetailerContacts.json?RetailerId=${$ctrl.retailerId}&IsPrimary=true`
      )
      .then(function (res) {
        if (res.data.results) {
          $ctrl.contact = res.data.results[0];
        }
      });
  }
  formSubmission(e, submission) {
    const $ctrl = this;
    $ctrl.formSubmitted = true;
    if (!$ctrl.hideForms) $ctrl.query.load();
  }
  requestForm(form) {
    const $ctrl = this;
    return requestPrompt({
      retailer: $ctrl.retailer,
      form: form,
      email: $ctrl.$cart.purchaser.email,
    }).then(function () {});
  }
  selectForm(form) {
    const $ctrl = this;
    $ctrl.selectedForm = {};
    $ctrl.formSubmitted = false;
    $ctrl.submission = {};
    $ctrl.selectedForm = form;

    formSubmissionPrompt(
      Object.assign({
        title: "Form Submission...",
        FormId: form.id,
        RefId: $ctrl.$cart.retailerId,
      })
    );
  }

  load() {
    return this.query.load.apply(this.query, arguments);
  }
}
